import { Config, InitializeTypes } from '@smiles/voebiz-core-engine';
import { getEnvFromHost } from 'utils/getEnvFromHost';

const env = getEnvFromHost();

const initializeConfig: InitializeTypes = {
  service: {
    environment: env,
    logger: false,
    timeout: 60000,
    region: 'Brasil',
  },
  channel: 'WEB',
  receiveConstants: true,
  loggerXstate: true,
};

export const init = async () => {
  const initialize = await Config.initialize(initializeConfig);

  const accessToken = String(localStorage.getItem('session-token'));

  Config.saveTokenAuthUser({ accessToken });

  return initialize;
};

export const handleRemoveToken = () => Config.removeTokenAuthUser();
